import React, { memo } from 'react'
import { string, func, object } from 'prop-types'
import {
  Container,
  Row,
  Col,
  Card,
  CaptionText,
  BodyText,
} from '@paypalcorp/pp-react'
import { fptiCustomClick, serverData } from '../utils'
const { locality = {} } = serverData
const directionality = locality.directionality || 'ltr'

const DWSubSection = memo((props) => {
  const {
    subSectionId,
    title,
    desc,
    iconName,
    onSectionClick,
    modal = null,
    navigateTo,
    fptiClickData,
    subModule = {},
  } = props

  const onClickSubSection = (type) => {
    if (!type) {
      fptiCustomClick(fptiClickData)
      if (!modal) {
        top.location.href = navigateTo
      } else {
        onSectionClick(modal)
      }
    }

    if (type === 'subModule') {
      const { modal: subModuleModal = null, navigateTo: subnavigateTo } =
        subModule
      fptiCustomClick(subModule.fptiClickData || {})
      if (!subModuleModal) {
        top.location.href = subnavigateTo
      } else {
        onSectionClick(subModuleModal)
      }
    }
  }

  const onClickSubModule = (e) => {
    e.stopPropagation()
    e.preventDefault()
    onClickSubSection('subModule')
    return false
  }

  const removeSubSectionHoverEffect = () => {
    const card = document.getElementById(subSectionId)
    const buttons = card.getElementsByClassName('dw-sub-section-card')
    buttons[0].classList.add('dw-sub-section-card-hover')
  }

  const addSubSectionHoverEffect = () => {
    const card = document.getElementById(subSectionId)
    const buttons = card.getElementsByClassName('dw-sub-section-card')
    buttons[0].classList.remove('dw-sub-section-card-hover')
  }

  return (
    <div id={subSectionId}>
      <Row align="center" noGutters>
        <Col xs={12} sm={8}>
          <button
            type="button"
            className="dw-sub-section-button dw-sub-section-card-container"
            onClick={() => onClickSubSection()}
          >
            <Card className="dw-sub-section-card">
              <Container fluid className="dw-sub-section-container">
                <Row align="start" noGutters>
                  <Col xs="auto" className="dw-subsection-icon-container">
                    {iconName}
                  </Col>
                  <Col xs={8} sm={9} md={10}>
                    <section
                      className={`dw-subsection-row-container ${directionality}`}
                    >
                      <BodyText className="dw-sub-section-title">
                        {title}
                      </BodyText>
                      {desc && (
                        <CaptionText className="dw-sub-section-desc">
                          {desc}
                        </CaptionText>
                      )}
                    </section>
                  </Col>
                </Row>
                {Object.keys(subModule).length > 0 && subModule.enabled() && (
                  <Row
                    id={subModule.subModuleId}
                    align="start"
                    noGutters
                    className="dw-sub-module"
                  >
                    <Col xs="auto" className="dw-sub-module-icon-container">
                      <div className="dw-sub-module-hide-icon" />
                    </Col>
                    <Col xs={12} sm={9} md={10}>
                      <a
                        href="#"
                        className={`dw-sub-module-button ${directionality}`}
                        onClick={(e) => onClickSubModule(e)}
                        onMouseEnter={() => removeSubSectionHoverEffect()}
                        onMouseLeave={() => addSubSectionHoverEffect()}
                      >
                        <Card className="dw-sub-module-card">
                          <Container fluid className="dw-sub-module-container">
                            <Row noGutters className="dw-sub-module-row">
                              <Col xs="auto" className="dw-hide-icon-container">
                                <div className="dw-sub-module-hide-inner-icon" />
                              </Col>
                              <Col
                                xs={9}
                                sm={10}
                                lg={12}
                                className="dw-sub-module-col"
                              >
                                <BodyText className="dw-sub-module-title">
                                  {subModule.title}
                                </BodyText>
                                <section className="sub-module-badge-container">
                                  <div className="dw-sub-module-badge">
                                    {subModule.badgeStatus()}
                                  </div>
                                  <CaptionText className="dw-sub-module-desc">
                                    {subModule.desc}
                                  </CaptionText>
                                </section>
                              </Col>
                            </Row>
                          </Container>
                        </Card>
                      </a>
                    </Col>
                  </Row>
                )}
              </Container>
            </Card>
          </button>
        </Col>
      </Row>
    </div>
  )
})

DWSubSection.propTypes = {
  title: object,
  desc: object,
  iconName: string,
  fptiClickData: object,
  navigateTo: string,
  modal: object,
  subModule: object,
  onSectionClick: func.isRequired,
}

DWSubSection.displayName = 'DWSubSection'

export default DWSubSection
